import React from 'react';

const Pay = () => {
    return (
        <div className="d-flex justify-content-center align-items-center" style={{ height: "100%" }}>

            <img className="img-fluid" src="https://i.ibb.co/jbC9YfN/coming-soon.jpg" alt="" />
        </div>
    );
};

export default Pay;